namespace $ {

	const $shm_hitalama_baza_gift_pass_installed = new WeakSet< object >()

	/** A peer's existing Face does not prove it has a NEW Gift's Mate Pass. */
	export function $shm_hitalama_baza_gift_pass_complete(
		land: $giper_baza_land,
		units: readonly $giper_baza_unit[],
	) {
		const known = new Set( units.filter( unit=> unit instanceof $giper_baza_auth_pass ).map( unit=> unit.lord().str ) )
		const missing: $giper_baza_auth_pass[] = []
		for( const unit of units ) {
			if( !( unit instanceof $giper_baza_unit_gift ) || !unit.mate().str ) continue
			if( known.has( unit.mate().str ) ) continue
			const pass = land.lord_pass( unit.mate() )
			if( !pass ) $mol_fail( new Error( 'Map grant is missing the recipient public key' ) )
			known.add( pass.lord().str )
			missing.push( pass )
		}
		return missing.length ? [ ... missing, ... units ] : units
	}

	/** Preserve native delta selection and cryptographic verification. */
	export function $shm_hitalama_baza_gift_pass_install( Land = $giper_baza_land ) {
		const proto = Land.prototype
		if( $shm_hitalama_baza_gift_pass_installed.has( proto ) ) return
		$shm_hitalama_baza_gift_pass_installed.add( proto )
		const native = proto.diff_units
		proto.diff_units = function( faces ) {
			return $shm_hitalama_baza_gift_pass_complete( this, native.call( this, faces ) ) as $giper_baza_unit[]
		}
	}

}
